export default __webpack_public_path__ + "static/media/1861.303505e4.png";